import { mdiChevronDoubleDown, mdiWhatsapp } from '@mdi/js';
import Icon from '@mdi/react';
import bg from '../../assets/bg-topo.jpg';
import './style.css';

function TopBg(){

    function handleOpenChat(){
        if(window.innerWidth <= 768){
            window.open('https://tintim.link/whatsapp/ae03a87e-b199-4b16-aed3-9bbcd95068c3/b3902c37-9caa-4a35-ae7b-d62e317a3e6b', '_blank')
        } else { 
            window.open('https://tintim.link/whatsapp/ae03a87e-b199-4b16-aed3-9bbcd95068c3/b3902c37-9caa-4a35-ae7b-d62e317a3e6b', '_blank')
        }
    }

    return(
        <section id='top' style={{
            backgroundImage: `url(${bg})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: '75vh',
            position: "relative",
            padding: '0px'
        }}>
            <div className="bg-black">
                <div className="bg-title">
                    <h1>BONÉS</h1>
                    <h1>PERSONALIZADOS</h1>
                    <p>Nossos produtos são cuidadosamente desenvolvidos para refletir a identidade da sua empresa, garantindo um produto único e memorável. Com materiais premium e um processo de fabricação minucioso, priorizamos a excelência em cada detalhe. Entre em contato com nossa equipe de vendas pelo Whatsapp <a href="https://tintim.link/whatsapp/ae03a87e-b199-4b16-aed3-9bbcd95068c3/2d7e4976-87f5-4edb-b971-f6b4b1b9e0b0" target="_blank">(47) 99749-6900</a> e solicite seu orçamento.</p>
                    <a className='wpp-action' onClick={handleOpenChat}>Fale Conosco<Icon path={mdiWhatsapp} size={1} /></a>
                </div>
            </div>
            <div className="roll-down">
                <a href="#" onClick={(e) => {
                    e.preventDefault()
                    window.scrollTo(0, 900)
                }}><Icon path={mdiChevronDoubleDown}/></a>
            </div>
        </section>
    )
}

export default TopBg;